import React from "react";
import { useDispatch } from "react-redux";
import { Typography, useTheme, Box } from "@mui/material";
import { IconBrain } from "../icons/BrainIcon";
import TallyDialog from "../dialog/TallyDialog";
import axios from "../../utils/axios.tsx";
import { conversationActions } from "../../store/conversation.tsx";
import { i18n } from "@lingui/core";
import { Trans } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

interface MemoryDrawerActionProps {
  closeDrawer: () => void;
}

const MemoryDrawerAction: React.FC<MemoryDrawerActionProps> = ({
  closeDrawer,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);

  const handleOpenDialog = () => {
    closeDrawer();
    setIsDialogOpen(true);
  };

  // Close the dialog
  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleCreateMemory = async (memoryText: string) => {
    await axios
      .post("/v1/memory/", JSON.stringify({ content: memoryText }))
      .then((response) => {
        dispatch(conversationActions.appendCustomActionResponse(response.data));
      });
    handleCloseDialog();
  };

  return (
    <React.Fragment>
      <Typography
        variant="h4"
        onClick={handleOpenDialog}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
          cursor: "pointer",
          whiteSpace: "nowrap",
          fontSize: "1rem !important",
          width: "100%",
          lineHeight: "1",
          margin: "0",
          py: "6px",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
            borderRadius: "25px",
          },
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "20px",
            height: "20px",
          }}
        >
          <IconBrain width="20px" height="20px" fontWeight={"light"} />
        </Box>
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "left",
          }}
        >
          <Trans context={"Span next to a button serving as a button title"}>
            Create a memory
          </Trans>
        </Box>
      </Typography>
      <TallyDialog
        open={isDialogOpen}
        title={i18n._(
          msg({
            context: "Button title enabling the user to create a memory",
            message: "Create a memory",
          }),
        )}
        subtitle={i18n._(
          msg({
            context:
              "Header with explanation what creating a memory does in the application.",
            message:
              "By creating a memory, I will learn the information so I can use it going forward in our conversations",
          }),
        )}
        submitTitle={i18n._(
          msg({
            context: "Button title for creation of a memory",
            message: "Create",
          }),
        )}
        onSubmit={handleCreateMemory}
        initialInputValue=""
        handleDialogClose={handleCloseDialog}
      />
    </React.Fragment>
  );
};

export default MemoryDrawerAction;
